import { ApolloClient, createNetworkInterface } from 'react-apollo';
import config from 'commons-garage/config/index.js';

export default function configureGraphQL(locale) {
    const networkInterface = createNetworkInterface({
        uri: config.endpoint.graphql,
        opts: {
            headers: {
                'accept-language': locale,
            },
        },
    });
    const client = new ApolloClient({
        networkInterface,
        partialResultsOnError: true,
    });

    return client;
}



// WEBPACK FOOTER //
// ./src/providers/apollo.js